import { render, staticRenderFns } from "./slproducttender.vue?vue&type=template&id=1d3a7bae&"
import script from "./slproducttender.vue?vue&type=script&lang=js&"
export * from "./slproducttender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports